// @flow
import { getDOMAspect, isLandscape, isRTL } from './Responsive.helper';
import { BREAKPOINTS, ORDERED_BREAKPOINTS } from './Responsive.constants';

function isBrowserGreaterThan(
  currentBreakpoint: Breakpoint,
  breakpoint: Breakpoint = BREAKPOINTS.XXS,
) {
  const currentBpIndex = ORDERED_BREAKPOINTS.indexOf(currentBreakpoint);
  const stepIndex = ORDERED_BREAKPOINTS.indexOf(breakpoint);
  return currentBpIndex > stepIndex;
}

function isDesktop(currentBreakpoint: Breakpoint) {
  return currentBreakpoint === BREAKPOINTS.L || currentBreakpoint === BREAKPOINTS.XL;
}

function isTablet(currentBreakpoint: Breakpoint) {
  return (
    isDesktop(currentBreakpoint) ||
    currentBreakpoint === BREAKPOINTS.M ||
    currentBreakpoint === BREAKPOINTS.S
  );
}

function isMobile(currentBreakpoint: Breakpoint) {
  return isTablet(currentBreakpoint) || currentBreakpoint === BREAKPOINTS.XS;
}

function getCurrentResponsive({
  currentBreakpoint,
  isAppMounted,
}: $Shape<ResponsiveProps>): ResponsiveProps {
  return {
    isAppMounted,
    currentBreakpoint,
    domAspect: getDOMAspect(isAppMounted),
    isLandscape: isLandscape(isAppMounted),
    isMobile: isMobile(currentBreakpoint),
    isRTL: isRTL(isAppMounted),
    isTablet: isTablet(currentBreakpoint),
    isDesktop: isDesktop(currentBreakpoint),
    isBrowserGreaterThan: {
      [BREAKPOINTS.XXS]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.XXS),
      [BREAKPOINTS.XS]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.XS),
      [BREAKPOINTS.S]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.S),
      [BREAKPOINTS.M]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.M),
      [BREAKPOINTS.L]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.L),
    },
  };
}
export default getCurrentResponsive;
